<template>
  <div class="service-record-dates">
    <div class="service-record-dates__section">
      <div class="service-record-dates__title-section">
        <div class="service-record-dates__label">Utført</div>
      </div>
      <div class="service-record-dates__border" />
      <div class="service-record-dates__value">
        {{ formattedServiceDate }}
      </div>
    </div>
    <div class="service-record-dates__section">
      <div class="service-record-dates__title-section">
        <div class="service-record-dates__label">Neste service</div>
      </div>
      <div class="service-record-dates__border" />
      <div class="service-record-dates__value">
        {{ formattedNextServiceDate || "-" }}
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from "vue";
import { formatDateInNorwegian } from "@/utilities/dateUtils";

interface Props {
  serviceDate: string;
  nextServiceDate?: string;
}

const props = defineProps<Props>();

// Computed properties for formatted dates
const formattedServiceDate = computed(() => {
  return formatDateInNorwegian(props.serviceDate, "DD.MM.YYYY");
});

const formattedNextServiceDate = computed(() => {
  if (!props.nextServiceDate) return "";
  return formatDateInNorwegian(props.nextServiceDate, "DD.MM.YYYY");
});
</script>

<style lang="scss" scoped>
.service-record-dates {
  display: flex;
  gap: 24px;
  margin-bottom: 1rem;

  @media (max-width: $bp-sm) {
    flex-direction: column;
    gap: 16px;
  }

  &__section {
    flex: 1;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: flex-start;
    gap: 8px;
  }

  &__title-section {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: flex-start;
  }

  &__label {
    font-size: $font-size-base;
    text-transform: uppercase;
    letter-spacing: 0.025em;
    color: $color-primary;
    font-weight: 600;
  }

  &__border {
    align-self: stretch;
    position: relative;
    background-color: $color-primary-light;
    height: 1px;
  }

  &__value {
    align-self: stretch;
    position: relative;
    font-size: $font-size-base;
    color: $color-primary-darker;
    font-weight: 400;
  }
}
</style>
